import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HeaderHelperService } from '../header-helper.service';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  editAccount(userData: any): Observable<any> {
    return this.http.put<any>(
      `${environment.apiLocations.identity}/Account`,
      userData,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  getGoogleAuth(): Observable<any> {
    {
      let url = `${environment.apiLocations.identity}/Authenticator/get-google-auth`;

      return this.http.get<any>(url, {
        headers: this.headerHelperService.getHeaders(),
      });
    }
  }

  sendEmailAuthForEnable(): Observable<any> {
    {
      let url = `${environment.apiLocations.identity}/Authenticator/send-email-auth-for-enable`;

      return this.http.get<any>(url, {
        headers: this.headerHelperService.getHeaders(),
      });
    }
  }
  sendEmailAuthForDisable(): Observable<any> {
    {
      let url = `${environment.apiLocations.identity}/Authenticator/send-email-auth-for-disable`;

      return this.http.get<any>(url, {
        headers: this.headerHelperService.getHeaders(),
      });
    }
  }

  enableGoogleAuth(form: any): Observable<any> {
    let url = `${environment.apiLocations.identity}/Authenticator/enable-google-auth`;

    return this.http.put<any>(url, form, {
      headers: this.headerHelperService.getHeaders(),
    });
  }
  disableGoogleAuth(form: any): Observable<any> {
    let url = `${environment.apiLocations.identity}/Authenticator/disable-google-auth`;

    return this.http.put<any>(url, form, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  enableEmailAuth(form: any): Observable<any> {
    let url = `${environment.apiLocations.identity}/Authenticator/enable-email-auth`;

    return this.http.put<any>(url, form, {
      headers: this.headerHelperService.getHeaders(),
    });
  }
  disableEmailAuth(form: any): Observable<any> {
    let url = `${environment.apiLocations.identity}/Authenticator/disable-email-auth`;

    return this.http.put<any>(url, form, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  putPassword(form?: any): Observable<any> {
    let url = `${environment.apiLocations.identity}/Account/change-password`;

    return this.http.put<any>(url, form, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  updateSecurityQuestion(form: any): Observable<void> {
    const url = `${environment.apiLocations.identity}/Account/security-question`;

    return this.http.put<void>(url, form, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  uploadProfilePhoto(form: FormData): Observable<any> {
    let url = `${environment.apiLocations.identity}/Account/upload-profile-photo`;

    return this.http.post<any>(url, form, {
      headers: this.headerHelperService.getHeaders(),
    });
  }
  deleteProfilePhoto(id: string): Observable<any> {
    let url = `${environment.apiLocations.identity}/Account/delete-profile-photo/${id}`;
    return this.http.delete<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }
}
